import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from '@mui/material';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import { ESIGN_MESSAGE } from '../../utils/utilityFunctions';

export function OfflinePaymentEsignPopup({
  onClose,
  onProceedWithEsign,
  proceedDisabled = false,
}: {
  onClose: () => void;
  onProceedWithEsign: () => void | Promise<void>;
  proceedDisabled?: boolean;
}): JSX.Element {
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          width: { xs: '95vw', sm: '600px', md: '700px' },
          borderRadius: 3,
          p: 1,
        },
      }}>
      <DialogTitle
        sx={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize: 22,
          pb: 1,
        }}>
        Offline payment selected
      </DialogTitle>

      <DialogContent sx={{ textAlign: 'center', px: 4, py: 2 }}>
        <Box display="flex" justifyContent="center" mb={1}>
          <AccountBalanceOutlinedIcon color="primary" sx={{ fontSize: 48 }} />
        </Box>

        <Typography variant="body1" sx={{ fontWeight: 500, mb: 2 }}>
          You have chosen to pay offline. Please proceed with E-Sign now to complete the process.
        </Typography>
 
      </DialogContent>

      <DialogActions
        sx={{
          px: 4,
          pb: 3,
          pt: 1,
          flexDirection: 'column',
          gap: 1,
        }}>
        <Button
          onClick={() => void onProceedWithEsign()}
          disabled={proceedDisabled}
          variant="contained"
          fullWidth
          size="large"
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            py: 1.4,
            fontSize: 16,
          }}>
          Proceed with e-Sign{proceedDisabled ? '…' : ''}
        </Button>
        <Typography
          sx={{
            mt: 2,
            fontSize: 14,
            fontWeight: 700,
            color: 'text.primary',
            lineHeight: 1.7,
            textAlign: 'left',
          }}>
          ** {ESIGN_MESSAGE} **
        </Typography>
      </DialogActions>
    </Dialog>
  );
}